var map = {
	"./bf5_rgba(0,0,0,0.7).jpg": "0aeca6399e",
	"./bioshock-infinite_rgba(0,0,0,0.7).jpg": "a12d62f7b5",
	"./dishonored-2_rgba(0,0,0,0.7).jpg": "586e369069",
	"./forza-horizon-4-b_rgba(0,0,0,0.7).jpg": "e61ed9ceb2",
	"./forza-horizon-4_rgba(0,0,0,0.7).jpg": "c273550b41",
	"./gow_rgba(0,0,0,0.7).jpg": "86d4476908",
	"./gta-5_rgba(0,0,0,0.7).jpg": "c0885c404f",
	"./horizon-zero-dawn_rgba(0,0,0,0.7).jpg": "c0c088762d",
	"./prey_rgba(0,0,0,0.7).jpg": "a9708942ae",
	"./rdr2-b_rgba(0,0,0,0.7).jpg": "095b498494",
	"./rdr2_rgba(0,0,0,0.7).jpg": "7aa4fea61b",
	"./shadow-of-the-colossus_rgba(0,0,0,0.7).jpg": "fd4c801c7f",
	"./skyrim_rgba(0,0,0,0.7).jpg": "57900b1d4a",
	"./spider-man_rgba(0,0,0,0.7).jpg": "48359ec294",
	"./titanfall_rgba(0,0,0,0.7).jpg": "844b636804",
	"./uncharted-4_rgba(0,0,0,0.7).jpg": "30ed5edafa",
	"./witcher_rgba(0,0,0,0.7).jpg": "58cb6f177a",
	"./zelda_rgba(0,0,0,0.7).jpg": "bb495c3832"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "62b8e37506";